exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fab-menu-inner .dropTargetClass .btn{color:orange!important}.selectedClass .btn{color:pink!important}.fab-menu-inner .ghostClass .btn{color:#8b008b!important}.draggedClass .btn{color:green!important}.toggleClass .btn{color:blue!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-c56a06cc","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/procedure/draggable-menu.vue
// module id = 1443
// module chunks = 0